// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"L1-z","displaySixCardTiles":"M1-z"};